// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__24qJO","location":"Header_location__3uRTr"};